import React from 'react';
import { theme } from 'codeArt/components/Base';
import { DataContext } from './context';
import { Util } from 'codeArt/common';

//在当前页面的路由表页面进行调用 否则不进行触发调用
export function importData() {
  DataContext.register([
    {
      name: "RI_SCORES",
      data: RI_SCORES
    }
  ]);

}

const RI_SCORES = [
  [
    20,30,10,90,95,40,45,50,
    55,25,34,66,90,95,40,45,
    50,62,33,25,34,78,67,55,
    44,33,22,11,56,67,43,57
  ],
  [
    44,33,22,11,56,67,43,57,
    50,62,33,25,34,78,67,55,
    33,39,27,56,78,64,69,77,
    52,43,41,25,77,46,81,33
  ],
  [
    33,39,27,56,78,64,69,77,
    44,33,22,11,56,67,43,57,
    62,77,41,80,81,85,86,45,
    33,39,27,56,78,64,69,77
  ],
];